import React from "react";

const DeliveryReturnPolicy = () => {
  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-sky-400 via-white/70 to-sky-200 text-slate-800">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl md:text-4xl font-bold mb-6 text-center">
          Delivery & Return Policy
        </h1>
        <p className="text-slate-700 text-base md:text-lg leading-relaxed mb-6 text-justify">
          At NFC Connect, we aim to deliver your NFC Smart Cards quickly and
          securely. Orders are typically processed within 24–48 hours after
          confirmation. Once shipped, you will receive a tracking link via email
          or WhatsApp.
        </p>

        <h2 className="text-xl md:text-xl font-bold mb-6">
          Delivery Information
        </h2>
        <p className="text-slate-700 text-base md:text-lg leading-relaxed mb-6 text-justify">
          • Standard Delivery: 3–5 business days.
          <br />
          • Express Delivery: 1–2 business days (available for select cities).
          <br />• International Shipping: 7–10 business days, customs fees may
          apply.
        </p>
        <p>
          Our packaging is eco-friendly and secure to ensure your NFC cards
          reach you in perfect condition.
        </p>

        <h2 className="text-xl md:text-xl font-bold mb-6 mt-6">
          Return & Replacement Policy
        </h2>
        <p className="text-slate-700 text-base md:text-lg leading-relaxed mb-6 text-justify">
          We take pride in our product quality. If your NFC card arrives damaged
          or defective, you may request a return or replacement within 7 days of
          delivery.
        </p>
        <p>
          • Items must be unused and in their original packaging.
          <br />
          • Return requests must include photos or a short video of the issue.
          <br />
          • Refunds or replacements will be processed once the returned item is
          inspected.
          <br />• Refunds are credited to the original payment method within 5–7
          business days.
        </p>
        <p>
          Note: Personalized or custom-printed NFC cards are not eligible for
          return unless damaged or defective.
        </p>

        <h2 className="text-xl md:text-xl font-bold mb-6 mt-6">
          Our Commitment
        </h2>
        <p className="text-slate-700 text-base md:text-lg leading-relaxed mb-6 text-justify">
          We stand by our NFC technology with a 6-month performance guarantee.
          If your NFC card stops functioning under normal use, contact us for a
          free replacement. We value your trust and ensure every card meets our
          highest standards of durability, performance, and quality.
        </p>

        <h2 className="text-xl md:text-xl font-bold mb-6 mt-6">
          Contact Information
        </h2>
        <p>
          For any questions about shipping, returns, or replacements, contact
          our support team at:
          <br />
          📧 taponnsolutions@gmail.com
          <br />
          📞 +971 58 177 0786
          <br />
          Customer service hours: Mon–Sat, 9:00 AM – 6:00 PM
        </p>
      </div>
    </section>
  );
};

export default DeliveryReturnPolicy;
